import React from 'react'
import branchesSocial from './branchesSocial.json'

interface BranchSocialProps {
  branchId?: number | string
  iconsStyle?: string
  className?: string
}

type BranchSocialEntry = {
  name?: string
  instagram?: string
  facebook?: string
  linkedin?: string
  youtube?: string
  twitter?: string
  tiktok?: string
}

// Redes sociales por sucursal, manejadas por JSON para no depender del CMS.
// Las claves son los IDs de sucursal (global_data.branches[].id) y hoy solo
// existen entradas para beber-luciano (tenant 124), así que el componente no
// renderiza nada para el resto de los clientes.
const BranchSocial = ({ branchId, iconsStyle = '', className = '' }: BranchSocialProps) => {
  const branchSocial = branchId
    ? (branchesSocial as Record<string, BranchSocialEntry>)[String(branchId)]
    : undefined

  if (!branchSocial) return null

  return (
    <div className={`branch-social ${className}`}>
      {branchSocial.instagram && (
        <a
          target="_blank"
          aria-label="Lea más en la red social instagram"
          href={branchSocial.instagram}
        >
          <i className={`icon icon-instagram${iconsStyle}`}></i>
        </a>
      )}
      {branchSocial.facebook && (
        <a
          target="_blank"
          aria-label="Lea más en la red social facebook"
          href={branchSocial.facebook}
        >
          <i className={`icon icon-facebook${iconsStyle}`}></i>
        </a>
      )}
      {branchSocial.linkedin && (
        <a
          target="_blank"
          aria-label="Lea más en la red social linkedin"
          href={branchSocial.linkedin}
        >
          <i className={`icon icon-linkedin${iconsStyle}`}></i>
        </a>
      )}
      {branchSocial.youtube && (
        <a
          target="_blank"
          aria-label="Lea más en la red social youtube"
          href={branchSocial.youtube}
        >
          <i className={`icon icon-youtube${iconsStyle}`}></i>
        </a>
      )}
      {branchSocial.twitter && (
        <a
          target="_blank"
          aria-label="Lea más en la red social twitter"
          href={branchSocial.twitter}
        >
          <i className={`icon icon-twitter${iconsStyle}`}></i>
        </a>
      )}
      {branchSocial.tiktok && (
        <a
          target="_blank"
          aria-label="Lea más en la red social tiktok"
          href={branchSocial.tiktok}
        >
          <i className={`icon-tiktok${iconsStyle}`}></i>
        </a>
      )}
    </div>
  )
}

export default BranchSocial
